module.exports = __webpack_public_path__ + "img/e978ee1.jpg";